module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Balloon-f458fc7a9e3cdb80f718d756e7b9f576.png";